export interface Partner {
  readonly name: string
  readonly logo: string
  readonly address: string
  readonly phone: string
  readonly website: string
  readonly remarks?: string
  readonly deprecated?: boolean
}

export interface PartnerWithId extends Partner {
  readonly id: string
}

export interface PartnersMap {
  [id: string]: Partner
}

export class PartnersService {
  readonly #partnersMap: PartnersMap
  list: ReadonlyArray<PartnerWithId>

  constructor (partnersMap: PartnersMap) {
    this.#partnersMap = partnersMap
    this.list = Object.entries(partnersMap).map(([id, partner]) => ({ ...partner, id }))
  }

  get (id: string): Partner | null {
    return this.#partnersMap[id] ?? null
  }
}
